export default [
  '-f',
  '--file',
  '--files'
] as const
